<div class="classification-area container">
  <div class="row"
    [style.minHeight.px]="rowHeight"
    [appHighlight]="highlightColor"
    [defaultColor]="defaultColor"
    (color)="handleMouseEvent( $event)">
    <div class="question" [ngClass]="cssClass">
      @if (questionNo) {
        <label class="question-no">{{questionNo}}</label>
      }
      <p class="title-area">{{question}}</p>
    </div>
    <div class="business-container"
      [ngClass]="componentClass">
      <form class="businessform" [formGroup]="classificationForm">
        @if (!autocomptypefield) {
          <div>
            <div cbInput label="Business description"
              hideRequiredMarker="true"
              [errorState]="classificationInvalid || (classificationInputCtrl.invalid && classificationInputCtrl.touched)"
              [class.has-error]="classificationInvalid || (classificationInputCtrl.invalid && classificationInputCtrl.touched)">
              <input id="keyWord" type="text" name="keyWord"
                [formControl]="classificationInputCtrl"
                (keyup)="classificationSelection()"
                (change)="classificationSelection()"
                (focusout)="handleFocusOut()" />
              </div>
              @if (classificationInvalid) {
                <p class="validationErrorMsg">{{errorMessages.businessClass.requiredinput}}</p>
              }
            </div>
          }
          @if (autocomptypefield) {
            <div>
              <div cbSearchInput [label]="placeHolder" colorTheme="default"
                styleVariant="default" sizeVariant="bodyRegular" paddingVariant="default"
                hideRequiredMarker="true">
                <div class="cb-search-input__wrapper">
                  <p-autoComplete
                    [formControl]="classificationInputCtrl"
                    [suggestions]="businessTypeSuggestions"
                    (completeMethod)="searchBusinessType($event)"
                    (onSelect)="classificationSelection()"
                    (onBlur)="onClassificationBlur()"
                    (onFocus)="onFocusShowAll()"
                    (onHide)="onDropdownHide()"
                    [minLength]="0"
                    [completeOnFocus]="true"
                    [scrollHeight]="'330px'"
                    [showClear]="false">
                    <ng-template pTemplate="item" let-item>{{ item.tts }}</ng-template>
                  </p-autoComplete>
                </div>
              </div>
              @if (classificationInvalid) {
                <p class="validationErrorMsg"
                  >
                  <span class="bgcircle">i</span>
                {{errorMessages.businessClass.required}}</p>
              }
              @if ((noMatch && !this.changeErrorMessage)) {
                <p class="validationErrorMsg"
                  >
                  <span class="bgcircle">i</span>
                {{errorMessages.businessClass.noMatch}}</p>
              }
              @if ((noMatch && this.changeErrorMessage)) {
                <p class="validationErrorMsg"
                  >
                  <span class="bgcircle">i</span>
                {{errorMessages.businessClass.noMatchForWalmart}}</p>
              }
            </div>
          }
        </form>
      </div>
    </div>


  </div>

